export enum ActorListTypeEnum {
  referee = 'referee',
  teamPlayer = 'teamPlayer'
}
